import { render, staticRenderFns } from "./RefundLogDialog.vue?vue&type=template&id=dc066e64&scoped=true"
import script from "./RefundLogDialog.vue?vue&type=script&lang=js"
export * from "./RefundLogDialog.vue?vue&type=script&lang=js"
import style0 from "./RefundLogDialog.vue?vue&type=style&index=0&id=dc066e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc066e64",
  null
  
)

export default component.exports